module.exports = __webpack_public_path__ + "static/media/13_portrait.df99e016.jpg";